export default [
    {
        path: '/pages/shop/shopConfig',
        name: '/pages/shop/shopConfig',
        meta: { title: '店铺设置' },
        component: () => import('@/views/shop/shopConfig.vue')
    },
    {
        path: '/pages/shop/shopIntegral',
        name: '/pages/shop/shopIntegral',
        meta: { title: '商家积分' },
        component: () => import('@/views/shop/shopIntegral.vue')
    },
    {
        path: '/pages/shop/shopSmsDetail',
        name: '/pages/shop/shopSmsDetail',
        component: () => import('@/views/shop/shopSmsDetail.vue')
    },
    {
        path: '/pages/shop/integralShopRule',
        name: '/pages/shop/integralShopRule',
        meta: { title: '积分规则' },
        component: () => import('@/views/shop/integralShopRule.vue')
    },
    {
        path: '/pages/shop/printerMachine',
        name: '/pages/shop/printerMachine',
        meta: { title: '打印设备' },
        component: () => import('@/views/shop/printerMachine.vue')
    },
    {
        path: '/pages/shop/printerMachineLog',
        name: '/pages/shop/printerMachineLog',
        meta: { title: '打印日志' },
        component: () => import('@/views/shop/printerMachineLog.vue')
    },
    {
        path: '/pages/shop/shop',
        name: '/pages/shop/shop',
        meta: { title: '店铺信息' },
        component: () => import('@/views/shop/shop.vue')
    },
    {
        path: '/pages/shop/shopAudit',
        name: '/pages/shop/shopAudit',
        meta: { title: '店铺变更' },
        component: () => import('@/views/shop/shopAudit.vue')
    },
    {
        path: '/pages/shop/shopAuditDetail',
        name: '/pages/shop/shopAuditDetail',
        component: () => import('@/views/shop/shopAuditDetail.vue')
    },
    {
        path: '/pages/shop/aShopData',
        name: '/pages/shop/aShopData',
        meta: { title: '店铺数据' },
        component: () => import('@/views/shop/aShopData.vue')
    },
    {
        path: '/pages/shop/aShopDetail',
        name: '/pages/shop/aShopDetail',
        component: () => import('@/views/shop/aShopDetail.vue')
    },
    {
        path: '/pages/shop/aShopSms',
        name: '/pages/shop/aShopSms',
        meta: { title: '店铺短信' },
        component: () => import('@/views/shop/aShopSms.vue')
    },
    {
        path: '/pages/shop/aShopSmsDetail',
        name: '/pages/shop/aShopSmsDetail',
        meta: { title: '短信记录' },
        component: () => import('@/views/shop/aShopSmsDetail.vue')
    },
    {
        path: '/pages/shop/cityArea',
        name: '/pages/shop/cityArea',
        meta: { title: '地区' },
        component: () => import('@/views/shop/cityArea.vue')
    },
    {
        path: '/pages/shop/integralShopGift',
        name: '/pages/shop/integralShopGift',
        meta: { title: '积分赠送' },
        component: () => import('@/views/shop/integralShopGift.vue')
    },
    {
        path: '/pages/shop/aShop',
        name: '/pages/shop/aShop',
        meta: { title: '店铺' },
        component: () => import('@/views/shop/aShop.vue')
    },
    {
        path: '/views/shop/shopServiceRule',
        name: '/views/shop/shopServiceRule',
        meta: { title: '服务费' },
        component: () => import('@/views/shop/shopServiceRule.vue')
    }
] 